import { Pipe, PipeTransform } from '@angular/core';
import {EnergieEnum} from '../suivi-des-consommations/enums/EnergieEnum';
import {EnergieService} from '../../../services/rt2012/energie.service';

@Pipe({
    name: 'energieUnit',
    standalone: false
})
export class EnergieUnitPipe implements PipeTransform {


  constructor(private energieService: EnergieService) {
  }

  transform(value: EnergieEnum): string {
    return this.energieService.getUnite(value);
  }

}
